import smallHeaderImage from '../assets/hotspot/headerImages/lily-s.jpg';
import largeHeaderImage from '../assets/hotspot/headerImages/lily-l.jpg';
import postcard from '../assets/hotspot/postcardPdf/LilyPostcard.pdf';
import postcardThumbnail from '../assets/hotspot/postcardImages/LilyPostcardThumbnail.jpg';
import introImage from '../assets/hotspot/intro/Meet_Lily.jpg.jpeg';
import concertThumbnail from '../assets/hotspot/celebrationPerformances/Lily_learn_concert.jpg.jpeg';

export const lily = {
  name: 'Lily',
  headerImages: [smallHeaderImage, largeHeaderImage],
  introVideo: {
    headline: 'Meet Lily, who sings Sephardi Ladino folk music!',
    details: '',
    vimeoLink: 'https://vimeo.com/1105192633?fl=pl&fe=sh',
    videoImage: introImage,
  },
  concertVideo: {
    videoLink: 'https://vimeo.com/1105192269?fl=pl&fe=sh',
    videoImage: concertThumbnail,
  },
  exploreLink: 'https://www.carnegiehall.org/Education/Programs/Musical-Explorers/Digital/Artists/Lily',
  postCard: {
    pdf: postcard,
    thumbnail: postcardThumbnail,
  },
  lessons: [
    {
      id: 1,
      type: 'audio',
      headline: 'Listen to Lily Sing "Si Veriash a la Rana"',
      link: 'Learn "Si Veriash a la Rana"',
      linkUrl: 'https://www.carnegiehall.org/Education/Programs/Musical-Explorers/Digital/Artists/Lily/Lesson-1',
      soundcloudEmbed: '<iframe width="100%" height="166" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/soundcloud%253Atracks%253A2137977129&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"></iframe>',
    },
    {
      id: 2,
      type: 'audio',
      headline: 'Listen to Lily Sing "Pesah a la Mano"',
      link: 'Learn "Pesah a la Mano"',
      linkUrl: 'https://www.carnegiehall.org/Education/Programs/Musical-Explorers/Digital/Artists/Lily/Lesson-2',
      soundcloudEmbed: '<iframe width="100%" height="166" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/soundcloud%253Atracks%253A2137984293&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"></iframe>',
    },
  ],
  traditionBlurb: 'Sephardi Ladino folk music is the musical tradition of the Sephardic Jews who were expelled from Spain in 1492. Sung in Ladino (Judeo-Spanish), these songs preserve centuries of cultural heritage, blending Spanish, Turkish, Greek, and other Mediterranean influences.',
  celebrationVideos: [
    {
      videoLink: 'https://vimeo.com/1105192269?fl=pl&fe=vl',
      videoImage: largeHeaderImage,
      songTitle: 'Pesah a la Mano',
      artistName: 'Lily',
      videoTags: [
        {
          tag: 'Purim',
        },
        {
          tag: 'Passover',
        },
      ],
      songDescription: '"Pesah a la Mano" ("Passover Is at Hand") is a Ladino song that celebrates the joyful transition from Purim to Passover. The lyrics express the love that goes into preparing for holidays, like cleaning the house and cooking traditional food to share. This song is one of many Ladino songs that connects generations through music.',
    },
  ],
};
